import { useState } from "react";
import { TContaCorrente } from "../../../types/api/financeiro/conta-corrente";
import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import DialogSelectItems from "./DialogSelectItems";
import { IDetalharTituloPagar } from "../../../types/api/financeiro/detalhar-titulo-pagar";
import ClearIcon from "@mui/icons-material/Clear";

export default function SelectContaCorrente({
  value,
  onChange,
  titulo,
  allowClear = false,
}: SelectContaCorrenteProps) {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const CustomInputComponent = ({ value, onClick }: CustomInputComponent) => {
    const commonStyles = {
      display: "flex",
      width: "100%",
      padding: "8px 12px",
      height: "56px",
    };

    if (!value)
      return (
        <TextField
          {...{ onClick }}
          variant="outlined"
          fullWidth
          slotProps={{
            input: { readOnly: true }
          }}
        />
      );

    return (
      <Box
        {...{ onClick }}
        sx={{
          ...commonStyles,
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography variant="subtitle2">
          {`${value.banco?.nome ?? ""} ${value.agencia}-${value.agencia_digito
            } ${value.conta}-${value.conta_digito}`}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      <TextField
        fullWidth
        label={"Conta Bancária"}
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          inputLabel: { shrink: Boolean(value) },
          input: {
            readOnly: true,
            inputComponent: () => (
              <CustomInputComponent
                {...{ value }}
                onClick={() => setOpenModal(true)}
              />
            ),
            endAdornment:
              allowClear && value ? (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Limpar"
                    edge="end"
                    size="small"
                    tabIndex={-1}
                    onClick={e => {
                      e.stopPropagation();
                      onChange(null);
                    }}
                  >
                    <ClearIcon style={{ color: "#888" }} />
                  </IconButton>
                </InputAdornment>
              ) : null
          }
        }}
      />

      {openModal && (
        <DialogSelectItems
          open={openModal}
          defValue={value}
          handleClose={() => setOpenModal(false)}
          title={"Conta Bancária"}
          onSubmitValue={onChange}
          titulo={titulo}
        />
      )}
    </>
  );
}

interface SelectContaCorrenteProps {
  value: Value;
  onChange: OnChangeValue;
  required?: boolean;
  titulo?: Partial<IDetalharTituloPagar>;
  allowClear?: boolean;
}

interface CustomInputComponent {
  value: Value;
  onClick: () => void;
}

export type Value = TContaCorrente | null;
export type OnChangeValue = (arg: TContaCorrente | null) => void;
